module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp2_8017.d7b9270d.png";